// Swebsocket.js
import store from '../store';

export function createWebSocket(clientId, userId) {
	let ws = null;
	let heartbeatWorker = null;
	let isOnline = false;
	let onMessageCallback = null;
	let swindowUnsubscribe = null;
	let reconnectTimer = null;
	let reconnectCount = 0;
	let isManualClose = false;

	// 消息队列：用于暂存连接未就绪时无法发送的消息
	let messageQueue = [];
	// 是否正在处理消息队列
	let isProcessingQueue = false;
	// 消息队列最大长�?
	const MAX_QUEUE_SIZE = 100;
	// 队列处理延迟时间（避免连续处理）
	let queueProcessTimer = null;

	const wsUrl = `wss://nmwtzx.com/wtzx/ws/${clientId}_${userId}`;

	// 添加消息到队�?
	function addMessageToQueue(content) {
		if (messageQueue.length >= MAX_QUEUE_SIZE) {
			// 队列已满，移除最旧的消息
			const removed = messageQueue.shift();
			// console.warn(`[WebSocket] 消息队列已满(${MAX_QUEUE_SIZE})，移除旧消息:`, removed);
		}

		messageQueue.push({
			content,
			timestamp: Date.now(),
			type: typeof content === 'string' ? 'string' : 'object'
		});
		// console.log(`[WebSocket] 消息已添加到队列，当前队列长�? ${messageQueue.length}`);

		// 如果有连接，尝试立即处理队列
		if (ws && ws.readyState === WebSocket.OPEN) {
			scheduleQueueProcessing();
		}
	}

	// 调度队列处理（防抖）
	function scheduleQueueProcessing() {
		if (queueProcessTimer) {
			clearTimeout(queueProcessTimer);
		}

		// 延迟处理，避免在短时间内多次处理
		queueProcessTimer = setTimeout(() => {
			processMessageQueue();
		}, 100);
	}

	// 处理消息队列
	async function processMessageQueue() {
		if (isProcessingQueue || messageQueue.length === 0) {
			return;
		}

		isProcessingQueue = true;

		try {
			// 创建队列的副本，避免在遍历过程中修改原数�?
			const queueToProcess = [...messageQueue];
			const failedMessages = [];

			// console.log(`[WebSocket] 开始处理消息队列，�?{queueToProcess.length}条消息`);

			for (const message of queueToProcess) {
				const now = Date.now();
				const messageAge = now - message.timestamp;

				// 如果消息超过5分钟，则不再发�?
				if (messageAge > 5 * 60 * 1000) {
					// console.warn(`[WebSocket] 消息已过�?${Math.round(messageAge/1000)}�?，跳�?`,
					// 	message.type === 'string' ? message.content : '[Object]');
					continue;
				}

				// 检查连接状�?
				if (!ws || ws.readyState !== WebSocket.OPEN) {
					// 连接未就绪，记录失败消息
					failedMessages.push(message);
					continue;
				}

				// 发送消�?
				const sendResult = sendMessageInternal(message.content);
				if (!sendResult) {
					// 发送失败，记录失败消息
					failedMessages.push(message);
				}

				// 为避免发送过快，每条消息之间添加微小延迟
				await new Promise(resolve => setTimeout(resolve, 50));
			}

			// 更新队列，只保留发送失败的消息
			messageQueue = failedMessages;

			// console.log(
			// 	`[WebSocket] 消息队列处理完成，成功发�?{queueToProcess.length - failedMessages.length}条，剩余${failedMessages.length}条`
			// 	);

		} catch (error) {
			// console.error('[WebSocket] 处理消息队列时发生错�?', error);
		} finally {
			isProcessingQueue = false;
		}
	}

	// 内部发送消息函�?
	function sendMessageInternal(content) {
		if (!ws || ws.readyState !== WebSocket.OPEN) {
			return false;
		}

		try {
			const sendData = typeof content === 'object' ? JSON.stringify(content) : content;
			ws.send(sendData);
			// console.log('[WebSocket] 已发送消�?', content);
			return true;
		} catch (error) {
			// console.error('[WebSocket] 发送消息失�?', error);
			return false;
		}
	}

	function reconnect() {
		if (isManualClose) {
			// console.log('[WebSocket] 手动关闭状态，跳过重连');
			return;
		}

		if (reconnectTimer) {
			clearTimeout(reconnectTimer);
			reconnectTimer = null;
		}

		if (ws && ws.readyState === WebSocket.OPEN) {
			return;
		}

		// console.log(`[WebSocket] 尝试重新连接... (�?{reconnectCount + 1}�?`);

		reconnectTimer = setTimeout(() => {
			reconnectCount++;
			// console.log(`[WebSocket] 执行�?{reconnectCount}次重连`);
			init();
		}, 100);
	}

	function sendImmediateLineCheck() {
		const currentSwindow = store.state.Swindow;
		if (currentSwindow) {
			// console.log('立即发送在线检测：', `line_${currentSwindow}`);
			sendMessage(`line_${currentSwindow}`);
		}
	}

	function setupSwindowListener() {
		if (swindowUnsubscribe) {
			swindowUnsubscribe();
		}

		swindowUnsubscribe = store.subscribe((mutation, state) => {
			if (mutation.type === 'setSwindow') {
				const newSwindow = mutation.payload;
				// console.log('Swindow 变化:', newSwindow);

				// 通知 Worker Swindow 更新
				if (heartbeatWorker) {
					heartbeatWorker.postMessage({
						type: 'updateSwindow',
						data: {
							swindow: newSwindow
						}
					});
				}

				if (isOnline && newSwindow) {
					setTimeout(() => {
						sendImmediateLineCheck();
					}, 100);
				}
			}
		});
	}

	function removeSwindowListener() {
		if (swindowUnsubscribe) {
			swindowUnsubscribe();
			swindowUnsubscribe = null;
		}
	}

	function initHeartbeatWorker() {
		// 停止现有�?Worker
		if (heartbeatWorker) {
			heartbeatWorker.terminate();
			heartbeatWorker = null;
		}

		// 创建新的 Worker
		try {
			heartbeatWorker = new Worker(new URL('./heartbeat.worker.js', import.meta.url));

			heartbeatWorker.onmessage = function(e) {
				const {
					type,
					data
				} = e.data;

				switch (type) {
					case 'heartbeat':
						// console.log('Worker 发送心�?', `ping_${data.clientId}_${data.userId}`);
						sendMessage(`ping_${data.clientId}_${data.userId}`);

						if (data.swindow) {
							sendMessage(`line_${data.swindow}`);
							// console.log('Worker 定时发送在线检测：', `line_${data.swindow}`);
						}
						break;

					case 'timeout':
						// console.warn('[WebSocket Worker] 心跳超时，判定对方离�?, data);
						if (isOnline) {
							isOnline = false;
							store.commit('setonline', isOnline);
							updateOnlineStatus();

							if (ws && ws.readyState !== WebSocket.OPEN && !isManualClose) {
								// console.log('[WebSocket] 心跳超时且连接异常，触发重连');
								reconnect();
							}
						}
						break;

					case 'log':
						// console.log('[Heartbeat Worker]', data);
						break;
				}
			};

			heartbeatWorker.onerror = function(error) {
				// console.error('[Heartbeat Worker] 错误:', error);
			};

		} catch (error) {
			// console.error('[WebSocket] 创建心跳 Worker 失败:', error);
			// 如果 Worker 创建失败，可以回退到原来的定时器方�?
			// console.log('[WebSocket] 将使用主线程心跳作为备选方�?);
		}
	}

	function startHeartbeat() {
		stopHeartbeat();

		if (heartbeatWorker) {
			// 使用 Worker 心跳
			const currentSwindow = store.state.Swindow;
			heartbeatWorker.postMessage({
				type: 'start',
				data: {
					clientId,
					userId,
					swindow: currentSwindow,
					startTime: Date.now()
				}
			});
		} else {
			// 备选方案：主线程心跳（保持原有逻辑�?
			// console.warn('[WebSocket] 使用主线程心跳作为备选方�?);
			// 这里可以保留原有的心跳逻辑作为备�?
		}
	}

	function stopHeartbeat() {
		if (heartbeatWorker) {
			heartbeatWorker.postMessage({
				type: 'stop'
			});
		}
	}

	function init() {
		if (!clientId || !userId) {
			// console.error('[WebSocket] 缺少 clientId �?userId，无法初始化连接');
			return;
		}

		isManualClose = false;

		if (ws) {
			ws.close(4000, '初始化新连接，关闭旧连接');
		}

		// 初始化心�?Worker
		initHeartbeatWorker();

		ws = new WebSocket(wsUrl);

		ws.onopen = () => {
			// console.log('[WebSocket] 连接成功', wsUrl);
			isOnline = true;
			store.commit('setonline', isOnline);
			reconnectCount = 0;
			updateOnlineStatus();

			setupSwindowListener();

			const currentSwindow = store.state.Swindow;
			if (currentSwindow) {
				setTimeout(() => {
					sendImmediateLineCheck();
				}, 500);
			}

			startHeartbeat();

			// 连接建立后立即处理积压的消息队列
			if (messageQueue.length > 0) {
				// console.log(`[WebSocket] 连接建立，开始处理积压的${messageQueue.length}条消息`);
				setTimeout(() => {
					processMessageQueue();
				}, 1000); // 延迟1秒，确保连接完全稳定
			}
		};

		ws.onmessage = (event) => {
			const rawData = event.data;
			// console.log('[WebSocket] 收到消息:', rawData);

			try {
				const parsedData = JSON.parse(rawData);
				if (parsedData.type === 'onlineStatus') {
					isOnline = parsedData.status;
					store.commit('setonline', isOnline);
					updateOnlineStatus();
				}
				onMessageCallback && onMessageCallback(parsedData);
			} catch (error) {
				// console.log('[WebSocket] �?JSON 格式消息:', rawData);

				if (rawData === 'pong') {
					// 通知 Worker 心跳响应
					if (heartbeatWorker) {
						heartbeatWorker.postMessage({
							type: 'response'
						});
					}
					isOnline = true;
					store.commit('setonline', isOnline);
					updateOnlineStatus();
				}

				if (rawData === 'online') store.commit('setotherline', '在线');
				if (rawData === 'noline') store.commit('setotherline', '离线');

				onMessageCallback && onMessageCallback(rawData);
			}
		};

		ws.onerror = (error) => {
			// console.error('[WebSocket] 连接错误:', error);
			isOnline = false;
			store.commit('setonline', isOnline);
			updateOnlineStatus();
		};

		ws.onclose = (event) => {
			// console.log(`[WebSocket] 连接关闭，代�? ${event.code}，原�? ${event.reason}`);
			isOnline = false;
			store.commit('setonline', isOnline);
			updateOnlineStatus();
			stopHeartbeat();

			removeSwindowListener();

			const normalCloseCodes = [1000, 4000];
			const abnormalCloseCodes = [1006, 1001, 1002, 1003, 1005, 1008, 1009, 1010, 1011];

			if (normalCloseCodes.includes(event.code)) {
				// console.log('[WebSocket] 正常关闭，不进行重连');
				if (store.state.mews === currentWsInstance) {
					store.commit('setmews', null);
				}
			} else if (abnormalCloseCodes.includes(event.code)) {
				// console.log(`[WebSocket] 检测到异常关闭(代码: ${event.code})，启动自动重连`);
				reconnect();
			} else {
				// console.log(`[WebSocket] 其他关闭代码: ${event.code}，启动重连`);
				reconnect();
			}
		};
	}

	// 对外提供的发送消息接�?
	function sendMessage(content) {
		if (!ws || ws.readyState !== WebSocket.OPEN) {
			// console.warn('[WebSocket] 连接未就绪，消息将加入队列等待发�?);

			// 检查是否是心跳或在线检测消�?
			if (typeof content === 'string') {
				// 心跳消息和在线检测消息不加入队列（这些消息有定时器会重新生成�?
				if (content.startsWith('ping_') || content.startsWith('line_')) {
					// console.log('[WebSocket] 心跳/在线检测消息，跳过队列');
					return false;
				}
			}

			addMessageToQueue(content);

			// 如果连接已关闭且不是手动关闭，触发重�?
			if (ws && ws.readyState === WebSocket.CLOSED && !isManualClose) {
				// console.log('[WebSocket] 连接已关闭，触发重连');
				reconnect();
			}

			return false;
		}

		// 连接正常，直接发�?
		return sendMessageInternal(content);
	}

	function updateOnlineStatus() {
		// console.log(`[WebSocket] 当前状�? ${isOnline ? '在线' : '离线'}`);
	}

	const currentWsInstance = {
		init,
		send: sendMessage,
		line: sendImmediateLineCheck,
		close: () => {
			// console.log('close 方法被调用，标记为手动关�?);
			isManualClose = true;

			if (reconnectTimer) {
				clearTimeout(reconnectTimer);
				reconnectTimer = null;
			}

			if (queueProcessTimer) {
				clearTimeout(queueProcessTimer);
				queueProcessTimer = null;
			}

			ws && ws.close(4000, '主动调用关闭');
			stopHeartbeat();
			removeSwindowListener();

			// 清理 Worker
			if (heartbeatWorker) {
				heartbeatWorker.terminate();
				heartbeatWorker = null;
			}

			// 清空消息队列
			if (messageQueue.length > 0) {
				// console.log(`[WebSocket] 关闭连接，清�?{messageQueue.length}条待发消息`);
				messageQueue = [];
			}

			if (store.state.mews === currentWsInstance) {
				store.commit('setmews', null);
			}
		},
		setOnMessageCallback: (callback) => onMessageCallback = callback,
		getIsOnline: () => isOnline,
		triggerLineCheck: () => {
			if (isOnline) {
				sendImmediateLineCheck();
			}
		},
		reconnect: () => {
			// console.log('[WebSocket] 手动触发重连');
			isManualClose = false;
			reconnect();
		},
		getReconnectCount: () => reconnectCount,
		// 新增方法：获取当前消息队列长�?
		getQueueLength: () => messageQueue.length,
		// 新增方法：手动处理消息队�?
		processQueue: () => processMessageQueue(),
		// 新增方法：清空消息队�?
		clearQueue: () => {
			// console.log(`[WebSocket] 清空消息队列，共${messageQueue.length}条消息`);
			messageQueue = [];
		}
	};

	return currentWsInstance;
}
